export {};
///**
// * Internal SDK configuration options
// * @internal
// */
//export interface IInternalSdkConfiguration {
//    /**
//     * [Optional] Enable Internal StatsBeat
//     * @internal
//     */
//    stats?: IStatsBeatConfig;
//}
//# sourceMappingURL=IConfiguration.js.map